<template>
	<div class="unishop-modal-cart" @click="showCarritoModal()">
		<!-- <div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">{{ modalTitle }}</p>
				<button class="delete" aria-label="close" @click="closeModal(false)"></button>
			</header>
			<section class="modal-card-body">
				<div v-if="!isCheckoutSection">
					<div class="box" v-for="product in products" :key="product.id">
						<button class="is-pulled-right button is-info is-inverted" @click="removeFromCart(product.id)">{{ removeLabel }}</button>
						<p>{{ product.title }}  {{ product.quantity > 0 ?  ` - Quantity: ${product.quantity}` : ''}}</p>
						<p>{{ product.price }} &euro;</p>
					</div>
					<div v-if="products.length === 0">
						<p>{{ cartEmptyLabel }}</p>
					</div>
				</div>
				<div v-if="isCheckoutSection">
					<p>You bought it :-)</p>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button v-show="products.length > 0 && !isCheckoutSection" class="button is-success" @click="onNextBtn">{{ buyLabel }}</button>
				<button v-if="isCheckoutSection" class="button is-success" @click="closeModal(true)">{{ closeLabel }}</button>
			</footer>
		</div> -->
		<div id="unishop-cart-wrap" class="unishop-cart-wrap" @click.stop="">
			<a class="unishop-modal-close carrito" @click="$store.commit('showCarritoModal', false)"></a>
			<div class="unishop-empty-message" v-if="products.length<1">El carrito esta vacío</div>
			<div>
				<ul class="unishop-cart-orders" v-if="products.length>0">
					<li v-for="product in products" :key="product.id">
						<div class="unishop-order-name">{{ product.modelo }} {{ product.color }}<span>{{ product.codigo }}</span></div>
						<div class="unishop-order-thumb" :style="{ backgroundImage: 'url(' + product.foto  + ')' }"></div>
						<div class="unishop-order-desc">
								<div class="unishop-order-price">
									<div><span>Precio:</span>{{ product.precio }}</div>
									<div><span>Cant:</span>{{ product.cantidad }}</div>
								</div>
								<div class="unishop-order-options"><span>Talla: {{ product.talla }}</span></div>
								<div class="unishop-order-subtotal"><span>{{ product.precio * product.cantidad }}&euro;</span>
								</div>
						</div>
						<a class="unishop-order-remove" @click="removeFromCart(product.id, product.codigo)" title="Eliminar"></a>
					</li>
				</ul>
				<div class="unishop-cart-total">
					<span>Unidades:&nbsp;{{ totalUds }}</span>
					<span>Subtotal:&nbsp;{{ subtotal }} &euro;</span>
					<span><strong>TOTAL:&nbsp; {{ total }} &euro;</strong></span>
				</div>
				<div>
						<v-text-field v-model="idCliente" placeholder="Cliente" @change="cambiarCliente"/>
				</div>
				<div class="tipo-ticket" v-show="!isSys4()">
					<v-select
						:items="tiposTicket"
						item-value="id"
						item-text="nombre"
						placeholder="Tipo"
						v-model="vTipo"
						attach
						@change="cambiarTipo" />
				</div>
				<div v-if="showFechaReserva">
						<v-checkbox
							v-model="reiniciarFecha"
							label="Reinicar fecha reserva"
						></v-checkbox>
				</div>
				<div class="unishop-cart-buttons">
					<v-btn @click="limpiar()">Borrar todo</v-btn>
					<v-btn color="primary" @click="aparcarTicket()">Aparcar<!-- <img style="margin-left:4px;" src='@/assets/images/Btn_aparcarTCK.png'>--></v-btn>
				</div>	
			</div>
		</div>
	</div>
</template>
<script>
import { TicketApiService } from '@/api/TicketApiService'
import { Util } from '@/api/Util'
const ticketApiService = new TicketApiService()
const util = new Util()
export default {
	name: 'checkout',
    
	data () {
		return {
			idCliente: "",
			tiposTicket: [{nombre:'Tienda', id : 0},{nombre:'Reserva', id : 1}],
			vTipo:0,
			reiniciarFecha: false,
			showFechaReserva: false
		}
	},

	computed: {
		products () {
			return this.$store.getters.getProductsCart;
		},
		subtotal () {
			let subtotal = 0;
			this.$store.getters.getProductsCart.forEach(element => {
				subtotal += element.precio * element.cantidad
			},subtotal);
			return subtotal.toFixed(2);
		},
		total () {
			let total = 0;
			this.$store.getters.getProductsCart.forEach(element => {
				total += element.precio * element.cantidad
			},total);
			return total.toFixed(2);
		},
		totalUds () {
			let totalUds = 0;
			this.$store.getters.getProductsCart.forEach(element => {
				totalUds += element.cantidad
			},totalUds);
			return totalUds;
		},
		cliente () {
			return this.$store.getters.getCliente
		}
		// 	openModal () {
		// 		if (this.$store.getters.isCheckoutModalOpen) {
		// 			return true;
		// 		} else {
		// 			return false;
		// 		}
		// 	},
		// 	buyLabel () {
		// 		let totalProducts = this.products.length,
		// 				productsAdded = this.$store.getters.productsAdded,
		// 				pricesArray = [],
		// 				productLabel = '',
		// 				finalPrice = '',
		// 				quantity = 1;

		// 		productsAdded.forEach(product => {

		// 			if (product.quantity >= 1) {
		// 				quantity = product.quantity;
		// 			}

		// 			pricesArray.push((product.price * quantity)); // get the price of every product added and multiply quantity
		// 		});

		// 		finalPrice = pricesArray.reduce((a, b) => a + b, 0); // sum the prices
				
		// 		if (totalProducts > 1) { // set plural or singular
		// 			productLabel = 'products';
		// 		} else {
		// 			productLabel = 'product';
		// 		}
		// 		return `Buy ${totalProducts} ${productLabel} at ${finalPrice}€`;
		// },
		// isUserLoggedIn () {
		// 	return this.$store.getters.isUserLoggedIn;
		// }
	},
	watch: {
		products (value) {
			if (value.length<1) {
				this.$store.commit('showCarritoModal', false)
			}
		},
		cliente(value) {
			if (value !== null) {
					this.idCliente = value.email
			} else {
				this.idCliente = null
			}
		}
	},
	created() {
		if (localStorage.getItem("tipoTicket") === null) {
			this.vTipo = 0
		} else {
			this.vTipo = parseInt(localStorage.getItem('tipoTicket'))
		}
		if (localStorage.getItem("idClienteTicket") === null) {
			if (this.cliente !== null) {
				this.idCliente = this.cliente.email
			} else {
				this.idCliente = ''
			}
		} else {
			this.idCliente = localStorage.getItem('idClienteTicket')
		}
		if (localStorage.getItem("fechaTicket") === null) {
			this.showFechaReserva = false
		} else {
			this.showFechaReserva = true
		}
	},
	methods: {
		cambiarTipo () {
			localStorage.setItem('tipoTicket', this.vTipo)
		},
		cambiarCliente () {
			localStorage.setItem("idClienteTicket", '')
		},
		showCarritoModal () {
			if (this.$store.getters.isCarritoModalOpen) {
				this.$store.commit('showCarritoModal', false);
			} else {
				this.$store.commit('showCarritoModal', true);
			}
    },
		// closeModal (reloadPage) {
		// 	this.$store.commit('showCheckoutModal', false);

		// 	if (reloadPage) {
		// 		window.location.reload();
		// 	}
		// },
		removeFromCart (id, codigo) {
			let data = {
					id: id,
					codigo: codigo
			}
			this.$store.commit('removeFromCart', data);
			
			// this.$store.commit('setAddedBtn', data);
		},
		aparcarTicket() {
			if (this.$store.getters.getProductsCart.length !== 0) {
				var ticketAux={
					cabecera: {
						msct_opuid : this.$store.getters.getOpuid,
						msct_tipo : this.vTipo,
						msct_puesto: "000",
						msct_id_cliente : this.idCliente
					}
				}
				if (localStorage.getItem("fechaTicket") !== null && this.vTipo === 1) {
					if (!this.reiniciarFecha) {
						Object.defineProperty(ticketAux.cabecera,'msct_fecha',{value: localStorage.getItem("fechaTicket")})
					}
				}
				let lineasTicketAux= {
					lineasticket : []
				}
				this.$store.getters.getProductsCart.forEach(element => {
					let lineaTicketAux= {
							mslt_codigo_escaneo : element.codigo,
							mslt_precio : element.precio,
							mslt_descuento: 0,
							mslt_unidades: element.cantidad,
						}
					lineasTicketAux.lineasticket.push(lineaTicketAux)
				},lineasTicketAux);
				Object.assign(ticketAux, lineasTicketAux)
				//ticketAux.push(lineasTicketAux)
				ticketApiService.addTicket(ticketAux)
					.then(data => {
						this.$store.state.productsCart=[]
						localStorage.removeItem('tipoTicket')
						localStorage.removeItem('idClienteTicket')
						localStorage.removeItem('fechaTicket')
						util.mostrarEnConsola('ticketApiService - addTicket', data.length, 'OK')
						this.showCarritoModal()
					})
					.catch(error => {
						this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
						util.mostrarEnConsola('ticketApiService - addTicket', error, 'ERROR')
						this.showCarritoModal()

					})
			}
		},
		limpiar() {
			this.showFechaReserva = false
			localStorage.removeItem('tipoTicket')
			localStorage.removeItem('idClienteTicket')
			localStorage.removeItem('fechaTicket')
			this.$store.state.productsCart=[]
		}
		// onNextBtn () {
		// 	if (this.isUserLoggedIn) {
		// 		this.isCheckoutSection = true;
		// 	} else {
		// 		this.$store.commit('showCheckoutModal', false);
		// 		this.$store.commit('showLoginModal', true);
		// 	}
		// },
		// onPrevBtn () {
		// 	this.isCheckoutSection = false;
		// }
	}
}
</script>

